import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, Instagram } from "lucide-react";

const WHATSAPP =
  "https://wa.me/919570216659?text=Hello%20THRIFTHOUSE,%20I'm%20interested%20in%20your%20curated%20collection.";

export const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-[#0B0C0E]" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 md:py-24 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <h3 className="font-display font-black text-3xl md:text-4xl tracking-[0.15em]">
            THRIFT<span className="text-neutral-600">HOUSE</span>
          </h3>
          <p className="mt-4 text-neutral-400 max-w-sm text-sm leading-relaxed">
            Curated men's fashion for the ones who don't follow the crowd. Luxury
            streetwear meets modern thrift.
          </p>
        </div>

        <div>
          <p className="font-mono-th text-xs uppercase tracking-[0.25em] text-neutral-500 mb-5">
            Explore
          </p>
          <div className="flex flex-col gap-3">
            <Link to="/shop" className="text-neutral-300 hover:text-white text-sm" data-testid="footer-shop">Shop</Link>
            <Link to="/shop?new=1" className="text-neutral-300 hover:text-white text-sm" data-testid="footer-new">New Stock</Link>
            <a href="/#categories" className="text-neutral-300 hover:text-white text-sm" data-testid="footer-categories">Categories</a>
            <a href="/#contact" className="text-neutral-300 hover:text-white text-sm" data-testid="footer-contact">Contact</a>
          </div>
        </div>

        <div>
          <p className="font-mono-th text-xs uppercase tracking-[0.25em] text-neutral-500 mb-5">
            Get in touch
          </p>
          <div className="flex flex-col gap-3">
            <a href="tel:9570216659" className="flex items-center gap-3 text-neutral-300 hover:text-white text-sm" data-testid="footer-phone-1">
              <Phone className="w-4 h-4" /> 9570216659
            </a>
            <a href="tel:9508859162" className="flex items-center gap-3 text-neutral-300 hover:text-white text-sm" data-testid="footer-phone-2">
              <Phone className="w-4 h-4" /> 9508859162
            </a>
            <a href={WHATSAPP} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-emerald-400 hover:text-emerald-300 text-sm" data-testid="footer-whatsapp">
              <MessageCircle className="w-4 h-4" /> WhatsApp us
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="font-mono-th text-xs text-neutral-600">© 2026 THRIFTHOUSE. ALL RIGHTS RESERVED.</p>
          <Link to="/admin" className="font-mono-th text-xs text-neutral-700 hover:text-neutral-400" data-testid="footer-admin-link">
            ADMIN
          </Link>
        </div>
      </div>
    </footer>
  );
};
